if (!customElements.get("special-offers-variant-radios")) {
  class SpecialOffersVariantRadios extends VariantRadios {
    constructor() {
      super();
    }

    onVariantChange(e) {
      super.onVariantChange(e);
      this.updateOtherVariantRadios(e);
    }

    updateVariantInput(e) {
      const currentTarget = e.currentTarget;
      const productForm = currentTarget.closest(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-gift-${this.dataset.section}`
      );
      let input = productForm.querySelector('input[name="id"]');

      let checkoutPropertyKey = productForm.querySelector(
        'input[name="checkout_property"]'
      );
      let checkoutPropertyValue = productForm.querySelector(
        'input[name="checkout_property_value"]'
      );

      if (this.dataset.fieldId !== undefined) {
        input = productForm.querySelector(
          `input[id="${this.dataset.fieldId}"]`
        );
      }
      if (checkoutPropertyKey && checkoutPropertyValue) {
        checkoutPropertyKey.value = this.currentVariant.metafields
          .v2_checkout_property_key
          ? this.currentVariant.metafields.v2_checkout_property_key
          : checkoutPropertyKey.dataset.default;
        checkoutPropertyValue.value = this.currentVariant.metafields
          .v2_checkout_property_value
          ? this.currentVariant.metafields.v2_checkout_property_value
          : checkoutPropertyValue.dataset.default;
      }

      input.value = this.currentVariant.id;
      e.preventDefault();
      //input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    updateOtherVariantRadios(e) {
      const currentTarget = e.currentTarget;
      const productForm = currentTarget.closest(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-gift-${this.dataset.section}`
      );
      //This is assuming all the products have the same options
      productForm
        .querySelectorAll(`input[type=radio][value='${e.target.value}']`)
        .forEach((radio) => {
          if (radio.id === e.target.id) return;
          radio.click();
        });
    }

    renderProductInfo(currentInput) {
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          variant: this.currentVariant,
        },
      });

      const labelShade = document.getElementById(
        currentInput.dataset.labelSelected
      );

      if (labelShade)
        labelShade.innerHTML =
          this.currentVariant[`option${currentInput.dataset.optionPosition}`];

      // const labelSize = document.getElementById(`size-${this.dataset.section}`);
      // if (labelSize) labelSize.innerHTML = this.currentVariant.option2;
    }
  }

  customElements.define(
    "special-offers-variant-radios",
    SpecialOffersVariantRadios
  );
}

if (!customElements.get("special-offers-vertical")) {
  class SpecialOffersVertical extends HTMLElement {
    constructor() {
      super();
      this.offers = this.querySelectorAll(".ps-offer-offers__item");
      this.variantSelectors = document.querySelectorAll(
        `special-offers-variant-radios[data-section="${this.dataset.section}"]`
      );

      for (let offer of this.offers) {
        offer.addEventListener("change", (e) => this.onOfferSelected(e));
      }
    }

    onOfferSelected(e) {
      const selectedOffer = e.target.parentElement.parentElement;
      const selectedOfferAddToCartButtonLabel =
        selectedOffer.dataset.addToCartLabel;

      if (selectedOffer.dataset.available === "false") {
        this.toggleAddButton(true, "", true);
      } else {
        this.toggleAddButton(
          false,
          true,
          true,
          selectedOfferAddToCartButtonLabel
        );
      }

      this.toggleGallerySection(e.target.dataset.productId);
      this.toggleVariantSelector(e.target.id);
      this.updateOneTimeShotButton(e.target.dataset.oneTimeButtonText);
    }

    toggleAddButton(
      disable = true,
      updateText = false,
      modifyClass = true,
      label
    ) {
      const productForm = document.querySelector(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #add-to-cart-form`
      );
      if (!productForm) return;
      const addButton = productForm.querySelector(".btn-add");
      const addButtonText = productForm.querySelector(".btn-add > span");
      if (!addButton) return;
      if (label != "") addButton.setAttribute("data-label", label);

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (updateText)
          addButtonText.innerHTML = addButton.getAttribute(
            "data-label-sold-out"
          );

        if (document.getElementById("nofify_sold-out")) {
          document.getElementById("nofify_sold-out").style.display = "block";
          addButton.style.display = "none";
        }
      } else {
        addButton.removeAttribute("disabled");
        if (updateText)
          addButtonText.innerHTML = addButton.getAttribute("data-label");

        if (document.getElementById("nofify_sold-out")) {
          document.getElementById("nofify_sold-out").style.display = "none";
          addButton.style.display = "block";
        }
      }

      if (!modifyClass) return;
    }

    toggleGallerySection(variantId) {
      const gallery = document.getElementById(
        `product-gallery-${this.dataset.section}-${variantId}`
      );

      const offerSection = document.querySelector(
        `offer-component[data-section='${this.dataset.section}']`
      );
      offerSection
        .querySelector(".ps-vertical-offers__gallery.active")
        ?.classList.remove("active");
      gallery?.classList.add("active");

      gallery
        .querySelectorAll("slider-component")
        .forEach((slider) => slider.rebuild());
    }

    toggleVariantSelector(offerId) {
      const variantSelector = document.querySelector(
        `#variant-radios-${offerId}`
      );
      if (variantSelector) {
        this.variantSelectors.forEach((variantSelector) => {
          variantSelector.classList.add("hidden");
        });
        variantSelector.classList.remove("hidden");
      }
    }

    updateOneTimeShotButton(buttonText) {
      const offerSection = document.querySelector(
        `offer-component[data-section='${this.dataset.section}']`
      );
      offerSection.querySelector(".ps-offer__buy-as-one-shot-link").innerHTML =
        buttonText;
    }
  }

  customElements.define("special-offers-vertical", SpecialOffersVertical);
}

if (!customElements.get("gifts-variant-radios")) {
  class GiftsVariantRadios extends VariantRadios {
    constructor() {
      super();
    }

    updateMedia() {
      try {
        if (!this.currentVariant) return;

        const mediaGalleries = document.querySelectorAll(
          `[id^="MediaGallery-${this.dataset.section}"]`
        );

        mediaGalleries.forEach((mediaGallery) => {
          const slide = mediaGallery.querySelector(
            `[data-variant-id='${this.currentVariant.id}']`
          );
          if (slide) mediaGallery.goToSlide(slide.dataset.slickIndex);
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  customElements.define("gifts-variant-radios", GiftsVariantRadios);
}

if (!customElements.get("special-offer-variant-radios")) {
  class SpecialOfferVariantRadios extends VariantRadios {
    constructor() {
      super();
    }

    updateVariantInput(e) {
      const currentTarget = e.currentTarget;
      const productForm = currentTarget.closest(
        `#product-form-special-offer-${this.dataset.section}`
      );

      let input = productForm.querySelector('input[name="id"]');
      let checkoutPropertyKey = productForm.querySelector(
        'input[name="checkout_property"]'
      );
      let checkoutPropertyValue = productForm.querySelector(
        'input[name="checkout_property_value"]'
      );

      if (this.dataset.fieldId !== undefined) {
        input = productForm.querySelector(
          `input[id="${this.dataset.fieldId}"]`
        );
      }

      if (checkoutPropertyKey && checkoutPropertyValue) {
        checkoutPropertyKey.value = this.currentVariant.metafields
          .v2_checkout_property_key
          ? this.currentVariant.metafields.v2_checkout_property_key
          : checkoutPropertyKey.dataset.default;
        checkoutPropertyValue.value = this.currentVariant.metafields
          .v2_checkout_property_value
          ? this.currentVariant.metafields.v2_checkout_property_value
          : checkoutPropertyValue.dataset.default;
      }

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  customElements.define(
    "special-offer-variant-radios",
    SpecialOfferVariantRadios
  );
}
